<template>
    <transition name="fade">
        <div class="page">
            <transition name="fade">
                <div class="signature-box" v-show="signatureShow">
                    <div :class="['signature', {show: seal}]">
                        <div class="redo" @click="clear"></div>
                        <div :class="['write', `type${seal}`]" ref="write">
                            <canvas
                                ref="canvas"
                                :width="canvasSize.width"
                                :height="canvasSize.height">
                            </canvas>
                        </div>
                        <div class="submit" @click="save"></div>
                    </div>
                    <div class="seals">
                        <div :class="['seal1', {active: seal === 1}]" @click="seal=1"></div>
                        <div :class="['seal2', {active: seal === 2}]" @click="seal=2"></div>
                    </div>
                </div>
            </transition>
            <div class="box">
                <!-- <span class="back" @click="back">返回</span> -->
                <span class="goon" @click="next">路过不留名</span>
                <div class="introduce" ref="introduce">
                    <div class="scroll"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import base from '@page/xuejinghanlintu/assets/base64';

export default {
    data() {
        return {
            rem: 100,
            signatureShow: false,
            seal: null,
            fontText: ['外来人，请留步。', '', '国画，融诗、书、', '画、印于一体，是', '一门综合性艺术。', '', '而印章，既是画家', '的自证，亦是藏者', '的雅趣。', '', '请挑选印章，留下', '你的专属印记。'],
            context: null,
            starX: 0,
            starY: 0,
            endX: 0,
            endY: 0
        };
    },
    computed: {
        canvasSize() {
            return {
                width: (this.seal === 1 ? 1.66 : 4.46) * this.rem,
                height: (this.seal === 1 ? 4.7 : 4.58) * this.rem
            };
        }
    },
    methods: {
        drowline() {
            const img = new Image();
            img.src = base[`type${this.seal}`];
            img.setAttribute('crossOrigin', 'Anonymous');
            img.onload = () => {
                this.context.drawImage(img, 0, 0, this.canvasSize.width, this.canvasSize.height);
            };
            this.context.beginPath();
            this.context.moveTo(this.starX, this.starY);
            this.context.lineWidth = 15;
            this.context.lineCap = 'round';
            this.context.strokeStyle = '#d55414';
            this.context.lineTo(this.endX, this.endY);
            this.context.stroke();
            this.starX = this.endX;
            this.starY = this.endY;
        },
        clear() {
            this.context.clearRect(0, 0, this.canvasSize.width, this.canvasSize.height);
        },
        save() {
            const { canvas } = this.$refs;
            const base64 = canvas.toDataURL('image/png', 1);
            const pics = JSON.parse(localStorage.getItem('pics')) || [];
            if (pics.length > 7) {
                pics.splice(0, 1);
            }
            pics.push(base64);
            localStorage.setItem('pics', JSON.stringify(pics));
            this.destroyEvnet();
            this.$emit('next', 7);
        },
        mousedown(e) {
            const client = e.touches[0];
            const clentX = (0.36 * this.rem) + ((7.14 * this.rem) - this.canvasSize.width) / 2;
            const clentY = (0.5 * this.rem) + ((5.14 * this.rem) - this.canvasSize.height) / 2;
            this.starX = client.clientX - clentX;
            this.starY = client.clientY - clentY;
            this.$refs.write.ontouchmove = event => {
                const c = event.touches[0];
                this.endX = c.clientX - clentX;
                this.endY = c.clientY - clentY;
                this.drowline();
            };
        },
        mouseup() {
            this.$refs.write.ontouchmove = null;
        },
        back() {
            this.destroyEvnet();
            this.$emit('back');
        },
        next() {
            const pics = JSON.parse(localStorage.getItem('pics')) || [];
            if (pics.length > 7) {
                pics.splice(0, 1);
            }
            pics.push('null');
            localStorage.setItem('pics', JSON.stringify(pics));
            this.destroyEvnet();
            this.$emit('next', 7);
        },
        destroyEvnet() {
            this.$refs.write.removeEventListener('touchstart', this.mousedown);
            this.$refs.write.ontouchmove = null;
            document.body.removeEventListener('touchend', this.mouseup);
        }
    },
    mounted() {
        this.rem = 100 * (document.documentElement.clientWidth / 750);
        setTimeout(() => {
            this.signatureShow = true;
        }, 2000);
        const { canvas } = this.$refs;
        this.context = canvas.getContext('2d');
        this.$refs.write.addEventListener('touchstart', this.mousedown);
        document.body.addEventListener('touchend', this.mouseup);
    }
};
</script>

<style lang="stylus" scoped>
.page
    background url('/img/xj/lv4.png') no-repeat
    background-size cover
    background-position center center
    .signature-box
        position absolute
        left 50%
        top .5rem
        size 7.14rem 8.68rem
        transform translate3d(-50%,0,1px)
        .signature
            size 7.14rem 5.14rem
            position relative
            background-color rgba(#fbecc3, 0.3)
            visibility hidden
            display flex
            align-items center
            justify-content space-between
            padding .2rem .5rem
            &.show
                visibility visible
            .redo
                size .61rem
                background url('/img/xj/btn_redo.png') 0 0/100% 100% no-repeat
                align-self flex-end
            .write
                size 4.46rem 4.58rem
                span
                    position absolute
                    size .02rem
                    background red
                &.type1
                    size 1.66rem 4.7rem
                    background url('/img/xj/seals_box_1.png') 0 0/100% 100% no-repeat
                &.type2
                    size 4.46rem 4.58rem
                    background url('/img/xj/seals_box_2.png') 0 0/100% 100% no-repeat
            .submit
                size .61rem
                background url('/img/xj/btn_submit.png') 0 0/100% 100% no-repeat
                align-self flex-end
        .seals
            width 100%
            padding-top .7rem
            display flex
            justify-content center
            align-items flex-end
            .seal1
                size .66rem 1.42rem
                background url('/img/xj/seal_1.png') 0 0/100% 100% no-repeat
                transition all .8s
                margin-right .5rem
                &.active
                    transform scale(1.3)
            .seal2
                size .99rem 1.03rem
                background url('/img/xj/seal_2.png') 0 0/100% 100% no-repeat
                transition all .8s
                &.active
                    transform scale(1.3)
    .box
        position absolute
        left 50%
        bottom .2rem
        size 7.14rem 3.38rem
        background-color #ede1c2
        opacity 0.78
        transform translate3d(-50%, 0, 1px)
        .back
            position absolute
            top -1rem
            left 0
            font-size .38rem
            color #fbecc2
        .goon
            position absolute
            top -1rem
            right 0
            font-size .38rem
            color #fbecc2
        .introduce
            position absolute
            left 50%
            top 50%
            transform translate3d(-50%, -50%, 1px)
            size 6.54rem 3.04rem
            padding .12rem 0
            border solid .02rem #5d2c1f
            background-color #ede1c2
            font-size .33rem
            color #303030
            opacity 0.78
            overflow-x auto
            overflow-y hidden
            .scroll
                height 100%
                opacity 0
                filter blur(12px)
                animation show 1.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards .2s
                size 100% 2.6rem
                background url('/img/xj/lv6_text_1.png') center center/auto 100% no-repeat
</style>
